<template>
  <modal v-if="isOpen" class-name="days-info-modal" @close="$emit('close')">
    <template #body>
      <div>
        <p>Solltest du feststellen, dass du nicht vollständig zufrieden bist, kannst du, gemäß §13 BGB als natürliche Person, innerhalb von 14 Tagen nach Entgegennahme deines Autos vom Widerrufsrecht Gebrauch machen.</p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};
</script>
<style lang="scss">
    .days-info-modal {
        p {
            font-family: "Asap", sans-serif;
            color: #3a3a3a;
            font-size: 16px;
            font-weight: normal;
            line-height: 21px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/modals/14DaysModal.vue